var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/lock-closed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.99961 11.8004H6.99961V10.8004V8.40039C6.99961 5.63897 9.23819 3.40039 11.9996 3.40039C14.761 3.40039 16.9996 5.63897 16.9996 8.40039V10.8004V11.8004H17.9996C18.7728 11.8004 19.3996 12.4272 19.3996 13.2004V19.2004C19.3996 19.9736 18.7728 20.6004 17.9996 20.6004H5.99961C5.22641 20.6004 4.59961 19.9736 4.59961 19.2004V13.2004C4.59961 12.4272 5.22641 11.8004 5.99961 11.8004ZM15.5996 11.8004H16.5996V10.8004V8.40039C16.5996 5.85988 14.5401 3.80039 11.9996 3.80039C9.4591 3.80039 7.39961 5.85988 7.39961 8.40039V10.8004V11.8004H8.39961H15.5996Z",
    fill: "#B296FF",
    stroke: "#B296FF",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.40022969133c7114857310e3e84b84bf.svg";
export { ForwardRef as ReactComponent };